var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 0h53.4v40H.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.3 0 27 20ZM27 0 .3 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 6.3,
    d: "M.3 0 27 20m0-20L.3 20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 32,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0v10h31.1v10H27zM27 0H13.7v23.3H.3V20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.3 0 27 20ZM27 0 .3 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 3.8,
    d: "M.3 0 27 20m0-20L.3 20"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.7 0v23.3ZM.3 10h31.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 9.4,
    d: "M13.7 0v23.3M.3 10h31.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.7 0v23.3ZM.3 10h31.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 6.3,
    d: "M13.7 0v23.3M.3 10h31.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 20H27V0h8.9v26.7H.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.7 16c0 7.5.8 10.1 2.4 11.9a15 15 0 0 0 3 2.5q1.5-1.1 2.8-2.5c1.7-1.8 2.5-4.4 2.5-12a6 6 0 0 1-2.9.9q-1.2-.2-2.5-.8-1.2.6-2.5.8a6 6 0 0 1-2.8-.8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M41.2 19.8c.2.6 1 1.2 1.3 1.6-.3.3-.4.3-.3.9q.5-.8.8-.5c.7.7.1 2.2-.5 2.5-.5.4-.4 0-1.3.4.4.4.9 0 1.2 0l.1 1.2c.3 0 .3-.7.4-1 .2-.9 1.7-1.5 1.7-2.3q.4-.2 1 .2c-.2-.8-.8-.8-1-1q-.4-1.1-1.5-1.5c-.6-.2-.6 0-1-.3-.3-.2-1-.5-.9-.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.9 20.6.1-.2h-.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M39.2 22.3c.4-.5.6-1.5.8-1.9.4.1.4.2.9-.1q-1-.2-.8-.5c.2-1 1.8-1.2 2.4-.8s.2.4 1 1c0-.5-.5-.8-.6-1.1l1-.6c-.2-.3-.8 0-1 .1-1 .2-2.1-.8-2.9-.5q-.4-.3-.3-1c-.6.6-.3 1.1-.4 1.4q-.7.9-.6 2.1c.2.6.3.5.3 1 0 .3 0 1.2.2 1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39 20.4q-.3 0-.1.2h.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M42.5 22.7c-.7-.1-1.7.3-2 .3-.2-.4-.1-.5-.6-.8q.2.9 0 1c-1 .3-2-1-2-1.7s.3-.4.4-1.4c-.5.2-.4.8-.7 1s-.5-.4-1-.4c-.1.3.5.6.6.8.7.6.4 2.2 1.1 2.7q0 .5-.6.8c.7.2 1-.3 1.3-.3q1.2.1 2-.6c.5-.5.3-.6.8-.8.3-.1 1-.6.7-.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41 23.7q-.1.1 0 .2h.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m37 26.3 1.1 1.6a15 15 0 0 0 3 2.5q1.5-1.1 2.8-2.5.8-.7 1.1-1.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdc301",
    d: "M35.4 15.7c0 7.8.9 10.5 2.6 12.4q1.4 1.5 3 2.5 1.7-1.1 3-2.5c1.8-1.9 2.6-4.6 2.6-12.4q-1.6.9-3 .8-1.4-.2-2.6-.8a7 7 0 0 1-2.6.8c-1 0-1.7-.2-3-.8m.4.4q1.5.8 2.8.8 1.3-.2 2.4-.8 1.1.6 2.5.8a6 6 0 0 0 2.8-.8c0 7.4-.8 10-2.4 11.7q-1.3 1.4-2.9 2.4-1.5-1-2.8-2.4c-1.6-1.7-2.4-4.3-2.4-11.7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.86cc90de06bf897f0b22bbd501f1e26f.svg";
export { ForwardRef as ReactComponent };